import React, { Component, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { API_URL } from '../../Actions/Config'
import OwlCarousel from "react-owl-carousel"
import DatePicker from "react-datepicker";
import AOS from "aos";
import Header from '../Common/Header'
import Footer from '../Common/Footer'
import Helmet from '../Common/Helmet'
import TourListing from "../Common/TourListing"
import { getBlogDetail } from "../../Actions/TourDetailsAction"
import { tourFb, tourTw, tourLn } from "../../Images"
import "aos/dist/aos.css";
import "../../css/mainUpdate.css";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "react-datepicker/dist/react-datepicker.css";

const mapStateToProps = (state) => {
    return {
        tourDetailsReducer: state.TourDetailsReducer
    }
}

const mapDispatchToProps = dispatch => ({
    getBlogDetail: (name) => dispatch(getBlogDetail(name))
});


function getPeragraph(description, count) {
    var Pera = description

    Pera = Pera.length > count ? Pera.substring(0, count) + "..." : Pera

    return Pera
}

function getBackgroudImage(news) {
    var image = ""
    image = news.image != undefined && news.image != '' ? API_URL + "/" + news.image : API_URL + news.home_image
    return image
}


class BlogDetails extends Component {

    constructor(props) {
        super(props);

        const { peram } = this.props.match.params;
        this.state = {
            
        }
        this.props.getBlogDetail(peram)
    }
    


    render() {

        const { news, related_tours } = this.props.tourDetailsReducer;
        var state = this.state

        return <Fragment>
            <Header home={false} />
            <Helmet
                title={"Tour List"}
                description={"Listing"}
            />
            {news != null ?
                <div className='main-container'>
                    <div className='maindiv'>

                        <div className="bannerwrapinner bannerwrapinner-new">
                            <div class="sliderwrap" style={{backgroundImage: `url(` + getBackgroudImage(news) + `)` ,backgroundSize:"cover",backgroundRepeat:"no-repeat",backgroundPosition:"left top",objectFit:"cover"}}>
                                <div class="breadcrumbs-wrap">
                                    <div class="container">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <div class="breadcrumbs" >
                                                    <a href="/">Home</a> <span className="sep"></span>
                                                    <a href="/blog">Blog </a> <span className="sep"></span>
                                                    <a>{news.title}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="contentwrap">
                        <div className="introwrap">
                            <div class="container">
                                <div class="row">
                                    <div class="col-lg-7">
                                        <h3>{news.title}</h3>

                                        <div
                                            dangerouslySetInnerHTML={{ __html: news.description }}
                                        />

                                        <div class="blog-share-wrap" style={{ fontFamily: "open_sansregular", fontSize: 14, lineHeight: 1.42857143, color: "#333" }}>

                                            <div class="blog-share-wrap-col"><span>Published Date</span>    <div class="p-date">{news.date}</div></div>

                                        </div>
                                    </div>
                                    <div class="col-lg-5 gray">
                                        <h4>Latest Posts</h4>
                                        {related_tours.length > 0 ? related_tours.map((post) => (

                                            <div class="rl-wrap">
                                                <div class="rl-thumb">
                                                    <img src={API_URL + "/" + post.image} alt="" />
                                                </div>
                                                <div class="rl-title">
                                                    <a href={"/news/"+ post.permalink}>
                                                        {getPeragraph(post.title, 60)}
                                                    </a>
                                                    <div class="rl-post-date">
                                                        {post.date}
                                                    </div>
                                                </div>
                                            </div>
                                        )) : null}
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div> : null}
            <Footer hyperLink={true} />
        </Fragment>
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(BlogDetails);